var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("Welcome to "),
      _c("b", [_vm._v("OXPERTA")]),
      _vm._v(" - a beautiful freebie for every web developer."),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }